import loading from './loading';
import order from './order';
import packages from './packages';
import priceTags from './priceTags';
import brochure from './brochure';
import user from './user';
import exports from './exports';
import product from './product';
import searchKeyword from './searchKeyword';
import registration from './registration';
import resources from './resources';
import homepage from './homepage';
import list from './list';
import cart from './cart';
import errors from './errors';

export default {
	errors,
	loading,
	order,
	packages,
	priceTags,
	brochure,
	user,
	exports,
	product,
	searchKeyword,
	registration,
	resources,
	homepage,
	list,
	cart
};



// WEBPACK FOOTER //
// ./src/App/redux/reducers/index.js